import { execute } from "./common";
import { BacktestAction } from "@/features/backtest";

export default function*() {
  yield execute([BacktestAction.fetchBacktestMeta.request()], state => state.backtest.loading.meta === "SUCCESS");
}
